var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language-box"},[_c('img',{staticClass:"image is-16x16",attrs:{"src":require("@/assets/images/flags/fr.png")},on:{"click":function($event){_vm.changeLocale('fr')}}}),_vm._v(" "),_c('img',{staticClass:"image is-16x16",attrs:{"src":require("@/assets/images/flags/en.png")},on:{"click":function($event){_vm.changeLocale('en')}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-354952cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SwitchLanguage.vue
// module id = null
// module chunks = 